import React from 'react';
import './Ventures.css';

function Ventures() {
  return (
    <section id="ventures" className="ventures-section">
      <div className="container">
        <h2 className="section-title">Our Work</h2>
        <div className="ventures-content">
          <p className="ventures-description">
            We are currently in the early stages of building and exploring multiple ideas
            within the health ecosystem.
          </p>
          <p className="ventures-description">
            Some ventures may begin quietly. Others may grow into standalone brands. All of
            them will align with our core mission — improving human health in meaningful ways.
          </p>
          <p className="ventures-announcement">
            More announcements coming soon.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Ventures;
